// extracted by mini-css-extract-plugin
export default {"monthly-chart":"MonthlySalesAmountChart_monthly-chart__2j+oD","action":"MonthlySalesAmountChart_action__1gsJG"};